import { Component, OnInit } from "@angular/core";
import { ProductsService } from "../service/products.service";
import { Product, ProductExcelField } from "cilor-db-api-shared";

@Component({
  selector: "app-products-page",
  templateUrl: "./products-page.component.html",
  styleUrls: ["./products-page.component.scss"]
})
export class ProductsPageComponent implements OnInit {
  public edit: boolean;

  constructor(
    public readonly productsService: ProductsService,
  ) {
    this.edit = false;
  }

  public async ngOnInit(): Promise<void> {
    this.productsService.loadProducts();
  }

  public async deleteProduct(product: Product): Promise<void> {
    await this.productsService.deleteProduct(product);
  }

  public toggleEdit(): void {
    this.edit = !this.edit;
  }
}
